module.exports = __webpack_public_path__ + "static/media/example_csv.6b6123c2.png";